"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon element-board", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { fill: "#C7C7C7", width: "30", height: "30", rx: "3.5" }),
            _react2.default.createElement("path", { d: "M1 3.196v23.608C1 28.019 1.982 29 3.196 29h23.608A2.194 2.194 0 0 0 29 26.804V3.196A2.194 2.194 0 0 0 26.804 1H3.196A2.194 2.194 0 0 0 1 3.196zm-1 0A3.194 3.194 0 0 1 3.196 0h23.608A3.194 3.194 0 0 1 30 3.196v23.608A3.194 3.194 0 0 1 26.804 30H3.196A3.194 3.194 0 0 1 0 26.804V3.196z", fill: "#A5A5A5" }),
            _react2.default.createElement("path", { fill: "#FFF", d: "M7 7h7v9.474H7zM7 18h7v5H7zM16 7h7v16h-7z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/element-board.js
// module id = 1858
// module chunks = 0